export default {
  metadata: {
    version: '1.0.0',
    id: 'carousel-slide-1.0.0',
    name: 'JDSCarouselSlide'
  },
  hierarchy: {
    container: ['slide-slot']
  },
  base: {
    container: {
      hidden: true,
      width: '{c_0}',
      'border-radius': '{c_1}',
      'enter-animation-name': 'slideHorizontallyToLeft',
      'exit-animation-name': 'slideHorizontallyToRight',
      'padding-left': '{xxs}',
      'padding-right': '{xxs}',
      'web-cursor': 'pointer'
    }
  },
  variant: {
    active: {
      true: {
        container: {
          hidden: false
        }
      }
    },
    forward: {
      false: {
        container: {
          'enter-animation-name': 'slideHorizontallyToRight',
          'exit-animation-name': 'slideHorizontallyToLeft'
        }
      }
    },
    _platform: {
      desktop: {
        container: {
          'padding-left': 0,
          'padding-right': 0
        }
      }
    }
  },
  combination: [{}],
  combination_config: [[]],
  api: {
    config: {
      active: {
        values: [false, true]
      },
      forward: {
        values: [true, false]
      },
      _platform: {
        values: ['tablet', 'desktop']
      }
    },
    children: {
      'slide-slot': {
        name: 'children',
        accepts: ['any'],
        max: 1
      }
    },
    events: {
      container: {
        onClick: 'onClick',
        onSwipeLeft: 'onSwipeLeft',
        onSwipeRight: 'onSwipeRight'
      }
    },
    data: {}
  }
};
